import { render, staticRenderFns } from "./StatusContaAzul.vue?vue&type=template&id=4dc6ca9c"
import script from "./StatusContaAzul.vue?vue&type=script&lang=js"
export * from "./StatusContaAzul.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports